import { useContext } from "react";
import { useNavigate } from "react-router";

//context
import appContext from "../context/appContext";

import {
  UilTachometerFastAlt,
  UilArrowGrowth,
  UilCreditCard,
  UilEllipsisH,
} from "@iconscout/react-unicons";

//api
import Api from "../api/newApi";
//style
import "../styles/components/bottomNavBar.scss";

const BottomNavBar = () => {
  const navigate = useNavigate();
  const { sideBarItemKey, setSideBarItemKey, userLogout } =
    useContext(appContext);

  // for change sideBar item
  const handleClick = (link, ikey) => {
    if (link && ikey) {
      setSideBarItemKey(ikey);
      navigate(link);
    }
  };

  // api for logout
  const logout = () => {
    Api.Post("user/logout").then((res) => {
      if (res.status === 200) {
        userLogout();
      }
    });
  };

  const ItemComponent = ({
    iKey = null,
    eventKey,
    icon,
    title,
    handleClick,
    link = null,
  }) => {
    return (
      <div
        onClick={() => handleClick(link, iKey)}
        className={`${
          eventKey === iKey ? "text-white" : ""
        } d-flex flex-column align-items-center item`}
      >
        {icon}

        <span
          className={`title  ${eventKey === iKey ? "visible" : "invisible"}`}
        >
          {title}
        </span>
      </div>
    );
  };

  return (
    <div className="bottomNavBar ">
      <div className=" py-2 d-flex justify-content-around  ">
        <ItemComponent
          icon={<UilEllipsisH />}
          iKey={"/more"}
          link={"/more"}
          eventKey={sideBarItemKey}
          handleClick={handleClick}
          title={"بیشتر"}
        />
        <ItemComponent
          icon={<UilTachometerFastAlt />}
          iKey={"/work"}
          link={"/work"}
          eventKey={sideBarItemKey}
          handleClick={handleClick}
          title={"ثبت حضور "}
        />
        <ItemComponent
          icon={<UilArrowGrowth />}
          iKey={"/statistics"}
          link={"/statistics"}
          eventKey={sideBarItemKey}
          handleClick={handleClick}
          title={"مشاهده آمار"}
        />
        {/* <ItemComponent
          icon={<ExitToApp />}
          eventKey={sideBarItemKey}
          handleClick={logout}
          title={"خروج"}
        /> */}
      </div>
    </div>
  );
};

export default BottomNavBar;
